import { Auth } from 'aws-amplify';

export const getUserClaims = (user) => {
  if (!user) {
    return {};
  }

  const tokenPayload = user?.signInUserSession?.idToken?.payload || {};
  const directAttributes = user?.attributes || {};
  const merged = { ...tokenPayload, ...directAttributes };

  if (!merged.email && typeof user?.username === 'string' && user.username.includes('@')) {
    merged.email = user.username;
  }

  return merged;
};

export const getUserAttribute = (user, key) => getUserClaims(user)[key] || '';

export const getCustomerId = (user) => getUserAttribute(user, 'custom:customer_id');

export const getUserEmail = (user) => {
  const claims = getUserClaims(user);
  return claims.email || claims['cognito:username'] || user?.username || 'User';
};

export const hydrateUser = async (user) => {
  if (!user) {
    return user;
  }

  const mergedAttributes = getUserClaims(user);

  try {
    const attributes = await Auth.userAttributes(user);
    attributes.forEach((attribute) => {
      if (attribute?.Name) {
        mergedAttributes[attribute.Name] = attribute.Value;
      }
    });
  } catch (error) {
    // Fall back to token/cache attributes when user attributes API fails.
  }

  return {
    ...user,
    attributes: mergedAttributes
  };
};
